import type React from 'react';
import channelLogisticsLogo from '@/assets/icons/channel-logistics-logo.png';
import { ActionButton } from '@/components/atoms/primitives';

interface SuccessStageProps {
  onLogin: () => void;
}

export const SuccessStage: React.FC<SuccessStageProps> = ({ onLogin }) => {
  return (
    <div className="flex flex-col items-center justify-center min-w-[600px] max-w-[600px] flex-shrink-0 h-full overflow-hidden relative">
      <div
        className="absolute right-4 bottom-4 w-[100px] h-[70px] bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${channelLogisticsLogo})` }}
      />
      <div className="flex flex-col w-[400px] h-[500px] overflow-y-auto">
        <header>
          <h1 className="text-2xl text-white font-bold mb-8">Password reset</h1>
        </header>

        <section aria-labelledby="success-message">
          <div id="success-message" className="text-gray-400 -mt-4 text-left" aria-live="polite" aria-atomic="true">
            Password reset successfully.
          </div>
        </section>

        <section aria-label="Form actions">
          <ActionButton variant="primary" onClick={onLogin} className="w-full text-center align-center" type="button">
            Log in
          </ActionButton>
        </section>
      </div>
    </div>
  );
};
